import StyledPageTitle from "./PageTitle.styled";

const PageTitle = StyledPageTitle;

export default PageTitle;
